import "components/form/Checkbox/Checkbox.scss";
import PropTypes from "prop-types";

function Checkbox({ children, id, label, checked, onChange }) {
  const kebabCase = string => string.replace(/([a-z])([A-Z])/g, '$1-$2').replace(/\s+/g, '-').toLowerCase()

  id = id || kebabCase(label);

  return (
    <div className="form-checkbox-container">
      <input type="checkbox"
             id={ id }
             checked={ checked && 'checked' }
             className="form-checkbox"
             onChange={ onChange }/>
      <label htmlFor={ id }>
        { children }
      </label>
    </div>
  );
}

Checkbox.propTypes = {
  id: PropTypes.any,
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func
}

export default Checkbox;
